
<el-skeleton :loading="isLoadingPlaces" animated class="persons-grid-cont">
  <template slot="template">
    <div class="persons-grid">
      <el-skeleton-item class="persons-loading" animated v-for="n in 8" :key="n" />
    </div>
  </template>
  <template>
    <div v-if="getAvailablePlaces" class="persons-grid">
      <el-button class="persons-button" v-for="n in visiblePlaces" :key="n" @click="handleNbCouvert(n)">
        {{ n }}
      </el-button>
      <el-button v-if="showSeeMore" class="persons-button see-more-button" @click="seeMore">
        Voir plus
      </el-button>
    </div>
  </template>
</el-skeleton>
